import { baseURL } from '../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';

//获取学员邀请信息
export const getInviteInfo = (id, config) => {
  return hMacAjax.get(
    baseURL + `/grt-student-service/student/v1/invitation/${id}`,
    {},
    config
  );
};

//获取学员配置信息
export const getConfigInfo = (id,config) => {
  return hMacAjax.get(baseURL + '/grt-student-service/open/student/v1/student-invite', {id}, config);
};

//确认加入
// export const submitInviteInfo = (id, data, config) => {
//   return hMacAjax.put(
//     baseURL +
//       `/grt-student-service/student/v1/invitation/${id}?phone_number=${data.phone_number}&captcha=${data.captcha}`,
//     {},
//     config
//   );
// };
export const submitInviteInfo = (data, config) => {
  return hMacAjax.post( baseURL + '/grt-student-service/student/v1/invitation', data, config);
};

// 获取学员完善信息
export const improveInfoDetail = (data, config) => {
  return hMacAjax.post(baseURL + '/grt-student-service/open/student/v1/student-invite/improve/detail',data, config);
};

// 学员完善信息提交
export const submitImproveInfo = (data, config) => {
  return hMacAjax.post(baseURL + '/grt-student-service/open/student/v1/student-invite/improve',data, config);
};